import { render, staticRenderFns } from "./OrdersAH.vue?vue&type=template&id=20ac134c"
import script from "./OrdersAH.vue?vue&type=script&lang=js"
export * from "./OrdersAH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports